import dayjs from "dayjs";
import { calendarSliceActions } from "@/features/calendar/model";
import { useAppDispatch, useAppSelector } from "@/services/store";
import type { Dayjs } from "dayjs";

export const useCalendarViewDashboard = () => {
  const dispatch = useAppDispatch();

  const { selectedDate } = useAppSelector((state) => state.calendarSlice);

  const onChange = (date: Dayjs) => {
    if (date.isSame(dayjs(selectedDate), "month")) {
      dispatch(calendarSliceActions.setSelectedDate(date.toISOString()));
      dispatch(calendarSliceActions.openDrawer());
    }
    dispatch(calendarSliceActions.updateDateRange(date.toISOString()));
  };

  return {
    selectedDate,
    onChange,
  };
};
